import Vue from 'vue'
import store from '@state/store'
Vue.prototype.$hasHomeService = () => {
  return store.getters['merchant/hasHomeService']
}

Vue.prototype.$hasSpaceModule = () => {
  return store.getters['merchant/hasSpaceModule']
}

Vue.prototype.$hasDeposit = () => {
  return store.getters['auth/hasDeposit']
}

// 可能需要一個在 merchant 裡面的關於發票的值來判斷
Vue.prototype.$hasInvoice = () => {
  return store.getters['merchant/hasHomeService']
}

Vue.prototype.$hasSpecial = () => {
  const type = ['dingbeauty']
  return store.getters['merchant/hasHomeService'] || type.includes(window.globalData.APP_TYPE)
}

Vue.prototype.$hasMemberLevel = () => {
  return store.getters['auth/hasMemberLevel']
}

Vue.prototype.$hasDayCare = () => {
  return store.getters['auth/hasDayCare']
}

Vue.prototype.$hasGoods = () => {
  return store.getters['auth/iaHasGoods']
}

/**
 * @description 用於整體樣式改變（如SCSS,logo,img預設樣式）
 */
Vue.prototype.$appType = () => {
  return process.env.VUE_APP_DEV_MODE
}

/**
 * @description merchant的多語系（處理語系、使用人問題判斷）
 */
Vue.prototype.$merchantI18n = () => {
  return store.getters['merchant/merchantI18n']
}

Vue.prototype.$invoiceSettingNumber = () => {
  return store.getters['merchant/invoiceSettingNumber']
}

Vue.prototype.$isIpetBooking = () => {
  return store.getters['merchant/isIpetBooking']
}

Vue.prototype.$isHasGoodsComponent = () => {
  return store.getters['merchant/isIpetBooking']
}

/**
 * @description 是否有開啟線上金流（merchant的cashflowSetting === 1，才是有開）
 */
Vue.prototype.$cashFlowSettingPass = () => {
  return store.getters['merchant/cashflowSettingPass']
}

Vue.prototype.$hasHotel = () => {
  return store.getters['auth/hasHotel']
}